console.log("✅ Dual Image block initialized");
